import { useState, useEffect } from "react";
import { WifiOff, PencilLine } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  return (
    <AnimatePresence>
      {offline && (
        <motion.div
          initial={{ y: -40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -40, opacity: 0 }}
          data-testid="offline-banner"
          className="fixed top-0 inset-x-0 z-[60] bg-amber-500 text-white text-center text-xs sm:text-sm font-semibold py-2 px-4 flex items-center justify-center gap-2 shadow-md">
          <WifiOff size={16} className="shrink-0" />
          <span className="flex items-center gap-1.5">Sin conexión — puedes seguir trabajando <PencilLine size={13} className="hidden sm:inline" /> (crear y editar expedientes). Se subirá todo al reconectar.</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
